var showAdminTools = true;

$(function() {
	if (isDefined(getCookie('showAdminTools'))) {
		devtoolToggle(getCookie('showAdminTools'), true);
	}
	else {
		devtoolToggle(true, true);
	}
});

global.devtoolToggle = function (state, noAnimation) {
	if (!$('.devtools').length) return false;

	if (!isDefined(state)) {
		if (showAdminTools) {
			state = 0;
		}
		else {
			state = 1;
		}
	}

    var animationSpeed = 250;
    if (noAnimation) animationSpeed = 0;

    if (!noAnimation) {
        setCookie('showAdminTools', (state) ? 1 : 0, 90);
    }

	if (state == 1 || state == true) {
		if (noAnimation) $('.adt').show(); else $('.adt').fadedSlideDown(animationSpeed);
		$('.menu--admin .mtool--enable').hide();
		$('.menu--admin .mtool--disable').css('display', 'inline-block');
		$('.menu--admin').addClass('toolbar--visible').removeClass('toolbar--hidden');
		$('body').addClass('adt--visible');
		showAdminTools = true;
	}
	else {
		if (noAnimation) $('.adt').hide(); else $('.adt').fadedSlideUp(animationSpeed);
		$('.menu--admin .mtool--enable').css('display', 'inline-block');
		$('.menu--admin .mtool--disable').hide();
		$('.menu--admin').css('overflow', 'hidden');
		$('.menu--admin').addClass('toolbar--hidden').removeClass('toolbar--visible');
		$('body').removeClass('adt--visible');
		showAdminTools = false;
	}
}

global.devtoolGrid = function() {
	$('.devtools__grid').toggleClass('devtools__grid--active');
	setLocalStorage('devtools__grid', $('.devtools__grid').hasClass('devtools__grid--active'))
}

global.devtoolBlocs = function() {
	$('body').toggleClass('devtools__blocs');
	setLocalStorage('devtools__blocs', $('body').hasClass('devtools__blocs'))
}

global.devtoolTitles = function() {
	$('body').toggleClass('devtools__titles');
	setLocalStorage('devtools__titles', $('body').hasClass('devtools__titles'))

	let prevLevel = null;
	$('h1, h2, h3, h4, h5, h6, h7, h8, h9').each(function() {
		let $currentHeading = $(this);
		let currentTagName = $currentHeading.prop('tagName').toLowerCase();
		let currentLevel = parseInt(currentTagName.substring(1));
		let isValid = false;

		if (!prevLevel && currentLevel == 1) isValid = true
		else if (currentLevel != 1 && currentLevel <= prevLevel + 1) isValid = true

		if (isValid) {
			$currentHeading.removeClass('title--error');
			$currentHeading.addClass('title--valid');
		} else {
			$currentHeading.removeClass('title--valid');
			$currentHeading.addClass('title--error');
		}

		prevLevel = currentLevel;
	});
}

global.devtoolAlt = function() {
	$('body').toggleClass('devtools__alt');
	setLocalStorage('devtools__alt', $('body').hasClass('devtools__alt'))

	if ($('body').hasClass('devtools__alt')) {
		$('img').each(function() {
			let alt = $(this).attr('alt');
			if (alt) {
				$(this).removeClass('img--error')
				$(this).addClass('img--valid')
			}
			else {
				$(this).removeClass('img--valid')
				$(this).addClass('img--error')
			}
			if (alt === undefined) alt = '[no alt]';
			else if (!alt) alt = '[blank alt]';
			$(this).after('<span class="devtools__imganotate">'+alt+'</span>')
		})
	}
	else {
		$('.devtools__imganotate').remove();
	}
}

global.devtoolBreakpoint = function() {
	const breakpoint = $('.devtools__breakpoints').find(':visible:last').attr('class')
	$('.mtool--dev-menu > .menu__link > .menu__label').last().text(breakpoint ?? 'Dev');
}

global.initAdt = function(target) {
	// Admin tools init
	target.find(".adt").each(function(index) {
		if ($(this).prev().hasClass('adt')) {
			$(this).prev().html($(this).html()+$(this).prev().html());
			$(this).remove();
		}
	})

	target.find('.adt__btn:not(.adtReady)').click(function() {
		var tool = $(this);
		adtPopup(tool.data('url'), tool.attr('title'), tool.data('icon'), tool.data('width'), tool.data('height'));
	}).addClass('adtReady');
	target.find('.adt:not(.adtReady)').addClass('adtReady');
}

$(document).ready(function() {
	devtoolBreakpoint();
    $(window).resize(devtoolBreakpoint);

	if (getLocalStorage('devtools__grid')) devtoolGrid();
	if (getLocalStorage('devtools__blocs')) devtoolBlocs();
	if (getLocalStorage('devtools__titles')) devtoolTitles();
	if (getLocalStorage('devtools__alt')) devtoolAlt();
});